import { DynamicRowConfig, FieldType, OptionType } from "@components/DynamicForm/DynamicForm";
import { RegisterOptions } from "react-hook-form";
import { getAwardsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Awards/Awards.drilldownData";
import { getCommercialLeasingOpportunitiesTabsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/CommericialLeasingOppurtunites/CommercialLeasingOpportunitiesDynamicTabs/CommercialLeasingOpportunitiesDynamicTabs.drilldown";
import { getBusinessOpportunityDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/drilldowndataForBusinessOpp";
import { getContactUsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/ContactUS/ContactUs.drilldownData";
import { getOurBrandDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurBrand/drilldownDataForOurBrand";
import { getOurPoliciesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurPolicies/drilldownDataForOurPolicies";
import { getOurPoliciesNextPageDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurPolicies/OurPolicies.NextPage.drilldown";
import { getOurProfileDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurProfile/drilldownDataForOurProfile";
import { getHomepageBannerDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/HomepageBanner/HomepageBanner.drilldownData";
import { getMainNavigationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/drilldownDataForMainNavigation";
import { getMediaCentreDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/MediaCentre/drilldownDataForMediaCentre";
import { getOrganisationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Organization/drilldownDataForOrganisation";
import { getStakeHoldersDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/StakeHolders.drilldowndata";
import { SubsidiaryKey } from "~/Modules/ECMS/CORPORATE/Forms/Subsidiaries/types";
import { getDynamicSubsidiariesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/SubsidiariesDynamic/SubsidiariesDynamic.drilldown";
import { getSubsidiariesNextPageDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/SubsidiariesDynamic/SubsidiariesNextPage.drilldown";
import { getCommunityFriendlyOrganisationDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/Community/CommunityFriendlyOrganisation.drilldowndata";
import { getCreatingInspiringWorkplaceDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/CreatingInspiringWorkplace/CreatingInspiringWorkplace.drilldowndata";
import { getEnvironmentalConsciousnessDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/EnvironmentalConsciousness/EnvironmentalConsciouness.drilldowndata";
import { getFtse4GoodDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/FTSE4Good/FTSE4Good.drilldowndata";
import { getMemorableAirportExperiencesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/MemorableAirportExepreince/MemorableAirportExperiences.drilldowndata";
import { getPractisingSensibleEconomicsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/PracticingSensibleEconomics/MainContent/MainContent.drilldowndata";
import { getReportsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/Reports/Reports.drilldownData";
import { getSustainabilityDrilldownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/Sustainability.drilldownData";
import { getSustainabilityHeadingDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/SustainabilityHeading.drilldownData";
import { getMilestonesDrilldowndata } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/Milestones/Milestones.drilldown";
import { getOurMilestonesDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/MilestonesNew/Milestones.drilldown";
import { getNewsDrilldownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/News/News.drilldown";
import { getOurClientsDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/OurClients/OurClients.drilldown";
import { getTrainingAcademyDrillDownData } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/TrainingAcademy.drilldown";
import { getOurAirportsDrillDownData } from "../Modules/ECMS/CORPORATE/Forms/CorporateProfile/OurAirports/drilldownDataCorporatePolicies";
export type ModuleConfig =
  | "cameraAccess"
  | "languagePopUp"
  | "purchaseLoginPopUp"
  | "logoutPopUp"
  | "VMSPopUp"
  | "faq"
  | "loginPopUp"
  | "userProfileSettings"
  | "purchaseSuccess"
  | "welcomePageForCalendar"
  | "purchaseQR"
  | "loginPage"
  | "announcement"
  | "brandingGuidelinesPageContent"
  | "managementIntegrityMessage"
  | "antiBriberyCorruption"
  | "whistleblowingProgram"
  | "whistleblowingPolicy"
  | "reportingConcern"
  | "ourBrand"
  | "ourProfile"
  | "ourStory"
  | "ourBusiness"
  | SubsidiaryKey
  | "airlineServices"
  | "codeOfEthicsForMalaysiaAirportsHoldingsBerhad"
  | "conditionsOfUseForMalaysiaAirportsHoldingsBerhad"
  | "energyPolicyForMalaysiaAirportsHoldingsBerhad"
  | "environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad"
  | "fraudPolicyForMalaysiaAirportsHoldingsBerhad"
  | "giftPolicyForMalaysiaAirportsHoldingsBerhad"
  | "noSmokingPolicyForMalaysiaAirportsHoldingsBerhad"
  | "policyInWorkplaceForMalaysiaAirportsHoldingsBerhad"
  | "privacyNoticeForMalaysiaAirportsHoldingsBerhad"
  | "privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad"
  | "procurementManualForMalaysiaAirportsHoldingsBerhad"
  | "riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad"
  | "occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad"
  | "sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad"
  | "stopWorkPolicyForMalaysiaAirportsHoldingsBerhad"
  | "antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad"
  | "sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad"
  | "termsOfConditionsForMalaysiaAirportsHoldingsBerhad"
  | "codeOfEthicsForSubsidiaries"
  | "conditionsOfUseForSubsidiaries"
  | "airportConsultancy"
  | "klInternationalAirport"
  | "kotaKinabaluInternationalAirport"
  | "kuchingInternationalAirport"
  | "langkawiInternationalAirport"
  | "penangInternationalAirport"
  | "melakaAirport"
  | "sultanAbdulAzizShahAirport"
  | "sultanAbdulHalimAirportAlorSetar"
  | "sultanAhmadShahAirportKuantan"
  | "sultanAzlanShahAirportIpoh"
  | "sultanIsmailPetraAirportKotaBharu"
  | "sultanMahmudAirportKualaTerengganu"
  | "bintuluAirport"
  | "limbangAirport"
  | "miriAirport"
  | "muluAirport"
  | "mukahAirport"
  | "sibuAirport"
  | "labuanAirport"
  | "lahadDatuAirport"
  | "sandakanAirport"
  | "tawauAirport"
  | "pangkorStolport"
  | "redangStolport"
  | "tiomanStolport"
  | "bakelalanStolport"
  | "barioStolport"
  | "belagaStolport"
  | "kapitStolport"
  | "lawasStolport"
  | "longAkahStolport"
  | "longBangaStolport"
  | "longLellangStolport"
  | "longSemadoStolport"
  | "longSeridanStolport"
  | "marudiStolport"
  | "kudatStolport"
  | "longPasiaStolport"
  | "sempornaStolport"
  | "istanbulSabihaGokcenAirport"
  | "manualWelcomePage"
  | "procurementPlanning";

export interface ModuleFields {
  fieldName: string;
  fieldValue: any;
  className: string;
  parseField?: string;
  type:
    | "number"
    | "text"
    | "textarea"
    | "image"
    | "checkbox"
    | "content"
    | "video"
    | "date"
    | "dateTime"
    | "pdf"
    | "select"
    | "dynamicRow"
    | "mobile"
    | "dateFormat";
  name: string;
  formType: FieldType;
  label: string;
  placeholder: string;

  validation?: RegisterOptions;
  options?: OptionType[];
  loadOptions?: (selectedModule?: any, currentAirport?: any) => Promise<OptionType[]>;
  editable?: boolean;
  hidden?: boolean;
  usedFileType?: string;
  note?: string;
  futureDateRestriction?: boolean;
  dynamicFormType?: string;
  autoFillFromYoutube?: boolean;
  autoYoutubeDuration?: boolean;
  rowConfig?: DynamicRowConfig[];
  showField?: (formValues: any) => boolean;
  imageDimension?: {
    width: number;
    height: number;
  };
  openUpload?: (fieldName: string, setValue: (name: string, value: string) => void) => void;
  uploadTrigger?: boolean;
  disabledPreviousDateTime?: boolean;
}

export const drilldownDataCorporate: any = async (id?: any) => {
  // const currentModule = getCurrentModule();
  // if (currentModule !== "CORPORATE") {
  //   return {};
  // }
  const policiesData = await getOurPoliciesDrillDownData();
  const airportData = await getOurAirportsDrillDownData();
  const profileData = await getOurProfileDrillDownData();
  const subsidiariesData = await getDynamicSubsidiariesDrillDownData();
  const practisingSensibleEconomicsData = await getPractisingSensibleEconomicsDrillDownData();
  const environmentalConsciousnessData = await getEnvironmentalConsciousnessDrillDownData();
  const creatingInspiringWorkplaceData = await getCreatingInspiringWorkplaceDrillDownData();
  const CommunityFriendlyOrganisationData = await getCommunityFriendlyOrganisationDrillDownData();
  const MemorableAirportExperiencesData = await getMemorableAirportExperiencesDrillDownData();
  const ftse4goodData = await getFtse4GoodDrillDownData();
  const sustainabilityData = await getSustainabilityDrilldownData();
  const milestonesData = await getMilestonesDrilldowndata(id);
  const sustainabilityReportsData = await getReportsDrillDownData();
  const newsData = await getNewsDrilldownData(id);
  const commercialLeasingOpportunitiesData = await getCommercialLeasingOpportunitiesTabsDrillDownData();
  console.log("drilldownData-data", commercialLeasingOpportunitiesData, profileData);
  return {
    malaysiaAirportsHoldingsBerhadOurPolicies: policiesData?.malaysiaAirportsHoldingsBerhadOurPolicies,
    subsidiariesOurPolicies: policiesData?.subsidiariesOurPolicies,
    nextPageOurPolicies: getOurPoliciesNextPageDrillDownData.nextPageOurPolicies,
    ourBrandNextPage: getOurBrandDrillDownData.ourBrandNextPage,
    internationalOurAirports: airportData?.internationalOurAirports,
    domesticOurAirports: airportData?.domesticOurAirports,
    stolportsOurAirports: airportData?.stolportsOurAirports,
    overseasOurAirports: airportData?.overseasOurAirports,
    ourProfile: profileData?.ourProfile,
    subsidiaries: subsidiariesData?.subsidiaries,
    nextPageSubsidiaries: getSubsidiariesNextPageDrillDownData.nextPageSubsidiaries,
    ourBrandPageContent: getOurBrandDrillDownData.ourBrandPageContent,
    ourBrandPageHeading: getOurBrandDrillDownData.ourBrandPageHeading,
    ourPoliciesPageHeading: getOurBrandDrillDownData.ourPoliciesPageHeading,
    ourAirportsPageHeading: getOurBrandDrillDownData.ourAirportsPageHeading,
    ourProfilePageHeading: getOurBrandDrillDownData.ourProfilePageHeading,
    news: getMediaCentreDrillDownData.news,
    introduction: getTrainingAcademyDrillDownData.introduction,
    latestNewsList: getTrainingAcademyDrillDownData.latestNewsList,
    awardsPageContent: getAwardsDrillDownData.awardsPageContent,
    awardsPageHeading: getAwardsDrillDownData.awardsPageHeading,
    awardsNextPage: getAwardsDrillDownData.awardsNextPage,
    homePageBanner: getHomepageBannerDrillDownData.homePageBanner,
    airlineIncentives: getBusinessOpportunityDrillDownData.airlineIncentives,
    practisingSensibleEconomicsMainContent: practisingSensibleEconomicsData.practisingSensibleEconomicsMainContent,
    practisingSensibleEconomicsSiderData: practisingSensibleEconomicsData.practisingSensibleEconomicsSiderData,
    environmentalConsciousnessMainContent: environmentalConsciousnessData.environmentalConsciousnessMainContent,
    environmentalConsciousnessSiderData: environmentalConsciousnessData.environmentalConsciousnessSiderData,
    creatingInspiringWorkplaceMainContent: creatingInspiringWorkplaceData.creatingInspiringWorkplaceMainContent,
    creatingInspiringWorkplaceSiderData: creatingInspiringWorkplaceData.creatingInspiringWorkplaceSiderData,
    communityFriendlyOrganisationMainContent:
      CommunityFriendlyOrganisationData.communityFriendlyOrganisationMainContent,
    communityFriendlyOrganisationSiderData: CommunityFriendlyOrganisationData.communityFriendlyOrganisationSiderData,
    memorableAirportExperiencesMainContent: MemorableAirportExperiencesData.memorableAirportExperiencesMainContent,
    memorableAirportExperiencesSiderData: MemorableAirportExperiencesData.memorableAirportExperiencesSiderData,
    ftse4goodMainContent: ftse4goodData.ftse4goodMainContent,
    communityFriendlyOrganisationFeatures: CommunityFriendlyOrganisationData.communityFriendlyOrganisationFeatures,
    creatingInspiringWorkplaceFeatures: creatingInspiringWorkplaceData.creatingInspiringWorkplaceFeatures,
    environmentalConsciousnessFeatures: environmentalConsciousnessData.environmentalConsciousnessFeatures,
    memorableAirportExperiencesFeatures: MemorableAirportExperiencesData.memorableAirportExperiencesFeatures,
    practisingSensibleEconomicsFeatures: practisingSensibleEconomicsData.practisingSensibleEconomicsFeatures,
    reportsMainContent: sustainabilityReportsData?.reportsMainContent,
    reportsFeatures: sustainabilityReportsData?.reportsFeatures,
    landing: sustainabilityData.landing,
    aboutAndLegal: getMainNavigationDrillDownData.aboutAndLegal,
    mainMenu: getMainNavigationDrillDownData.mainMenu,
    childMenus: getMainNavigationDrillDownData.childMenus,
    grandChildMenus: getMainNavigationDrillDownData.grandChildMenus,
    servicePortals: getMainNavigationDrillDownData.servicePortals,
    socialMedia: getMainNavigationDrillDownData.socialMedia,
    managementTeamPageContent: getOrganisationDrillDownData.managementTeamPageContent,
    companyStructurePageContent: getOrganisationDrillDownData.companyStructurePageContent,
    boardOfDirectorsPageContent: getOrganisationDrillDownData.boardOfDirectorsPageContent,
    managementTeamPageHeading: getOrganisationDrillDownData.managementTeamPageHeading,
    companyStructurePageHeading: getOrganisationDrillDownData.companyStructurePageHeading,
    boardOfDirectorsNextPage: getOrganisationDrillDownData.boardOfDirectorsNextPage,
    boardOfDirectorsPageHeading: getOrganisationDrillDownData.boardOfDirectorsPageHeading,
    managementNextPage: getOrganisationDrillDownData.managementNextPage,
    trainingFacilities: getTrainingAcademyDrillDownData.trainingFacilities,
    ourClients: getOurClientsDrillDownData.ourClients,
    trainingAcademyBanner: getTrainingAcademyDrillDownData.trainingAcademyBanner,
    accreditationAndCertifications: getTrainingAcademyDrillDownData.accreditationAndCertifications,
    videoSection: getTrainingAcademyDrillDownData.videoSection,
    milestones: milestonesData?.milestones,
    agencies: getStakeHoldersDrillDownData.agencies,
    airlines: getStakeHoldersDrillDownData.airlines,
    cargo: getStakeHoldersDrillDownData.cargo,
    groundHandlers: getStakeHoldersDrillDownData.groundHandlers,
    agenciesPageHeading: getStakeHoldersDrillDownData.agenciesPageHeading,
    airlinesPageHeading: getStakeHoldersDrillDownData.airlinesPageHeading,
    groundHandlersPageHeading: getStakeHoldersDrillDownData.groundHandlersPageHeading,
    cargoPageHeading: getStakeHoldersDrillDownData.cargoPageHeading,
    groundHandlersNextPage: getStakeHoldersDrillDownData.groundHandlersNextPage,
    agenciesNextPage: getStakeHoldersDrillDownData.agenciesNextPage,
    airlinesNextPage: getStakeHoldersDrillDownData.airlinesNextPage,
    cargoNextPage: getStakeHoldersDrillDownData.cargoNextPage,
    // parentHeader: getNavigationDrillDownData.parentHeader,
    // childHeader: getNavigationDrillDownData.childHeader,
    // grandChildHeader: getNavigationDrillDownData.grandChildHeader,
    reportsPageHeading: getSustainabilityHeadingDrillDownData.reportsPageHeading,
    ftse4GoodPageHeading: getSustainabilityHeadingDrillDownData.ftse4GoodPageHeading,
    memorableAirportExperiencesPageHeading:
      getSustainabilityHeadingDrillDownData.memorableAirportExperiencesPageHeading,
    communityFriendlyOrganisationPageHeading:
      getSustainabilityHeadingDrillDownData.communityFriendlyOrganisationPageHeading,
    creatingInspiringWorkplacePageHeading: getSustainabilityHeadingDrillDownData.creatingInspiringWorkplacePageHeading,
    environmentalConsciousnessPageHeading: getSustainabilityHeadingDrillDownData.environmentalConsciousnessPageHeading,
    practisingSensibleEconomicsPageHeading:
      getSustainabilityHeadingDrillDownData.practisingSensibleEconomicsPageHeading,
    landingPageHeading: getSustainabilityHeadingDrillDownData.landingPageHeading,
    corporatePageHeading: getContactUsDrillDownData.corporatePageHeading,
    airportsPageHeading: getContactUsDrillDownData.airportsPageHeading,
    corporateCommunication: getContactUsDrillDownData.corporateCommunication,
    corporateAddress: getContactUsDrillDownData.corporateAddress,
    corporateMap: getContactUsDrillDownData.corporateMap,
    corporatePageContent: getContactUsDrillDownData.corporatePageContent,
    corporateNextPage: getContactUsDrillDownData.corporateNextPage,
    latestNews: newsData?.latestNews,
    commercialLeasingOpportunities: commercialLeasingOpportunitiesData?.commercialLeasingOpportunities,
    commercialLeasingOpportunitiesNextPage: getBusinessOpportunityDrillDownData?.commercialLeasingOpportunitiesNextPage,
    commercialLeasingOpportunitiesMainContent:
      commercialLeasingOpportunitiesData?.commercialLeasingOpportunitiesMainContent,
    commercialLeasingOpportunitiesFormValues:
      commercialLeasingOpportunitiesData?.commercialLeasingOpportunitiesFormValues,
    localClients: getOurClientsDrillDownData.localClients,
    internationalClients: getOurClientsDrillDownData.internationalClients,
    ourClientsMainContent: getOurClientsDrillDownData.mainContent,
    milestoneOverview: getOurMilestonesDrillDownData.milestoneOverview,
    milestoneLinks: getOurMilestonesDrillDownData.milestoneLinks,
  };
};
